import {Chip, Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {TabTypeDto} from '../../types'

type TabFilterValue = TabTypeDto | 'all'

type EditKpisTabFilterProps = {
  value: TabFilterValue
  onChange: (value: TabFilterValue) => void
}

const TAB_OPTIONS: TabFilterValue[] = [
  'all',
  TabTypeDto.ProcessEngineer,
  TabTypeDto.QualityEngineer,
  TabTypeDto.ReliabilityEngineer,
  TabTypeDto.SystemsEngineer,
  TabTypeDto.OutagePlanning,
  TabTypeDto.OptimizationSpecialist
]

export const EditKpisTabFilter = ({value, onChange}: EditKpisTabFilterProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const getLabel = (tab: TabFilterValue): string => {
    if (tab === 'all') {
      return t('tabs.all')
    }
    return t(`tabs.${tab}`)
  }

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {TAB_OPTIONS.map((tab) => (
        <Chip
          key={tab}
          label={getLabel(tab)}
          onClick={() => onChange(tab)}
          color={value === tab ? 'primary' : 'default'}
          variant={value === tab ? 'filled' : 'outlined'}
          size="small"
        />
      ))}
    </Stack>
  )
}
